import { object, string, ref } from "yup"

export default object({
  username: string().required("Username is required!").label("Username"),
  password: string().required("Password is required!").label("Password"),
})

export const changePassword = object({
  password: string().min(5).required("Password is required"),
  passwordConfirmation: string().oneOf(
    [ref("password"), null],
    "Passwords must match"
  ),
})
